<template>
  <div class="feedbackDetail">
    <div class="mask"></div>
    <div class="main">
      <div class="top">
        <span class="back" @click="clearCurrFeedbackId"><i class="iconfont icon-zuojiantou"></i></span>
        <h2>{{feedbackInfo.createddate}} 留言反馈详情</h2>
      </div>
      <div class="question">
        <h3 class="describe">留言反馈：</h3>
        <div v-html="feedbackInfo.describe" class="describe"></div>
        <ul class="imageList">
          <li v-for="image in questionImageList">
            <img :src="image.path" alt="">
          </li>
        </ul>
      </div>
      <div v-for="reply in answerList" class="answer">
        <h3 class="describe">{{reply.username}}回复：</h3>
        <div v-html="reply.content" class="describe"></div>
        <p class="time">{{reply.time}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  //axios
  import axios from 'axios';
  import apiConfig from 'common/js/api_config';

  export default {
    name: "feedbackDetail",
    data() {
      return {
        feedbackInfo: {},
        questionImageList: [],
        answerList: [],
      }
    },
    props:{
      feedbackId:{
        type:Number,
      }
    },
    computed: {},
    methods: {
      async _initFeedbackInfo(){
        let feedbackInfo=await axios.post(apiConfig.REQUEST_URL+'/ehall/front_getSuggestionInfo',{
          id:this.feedbackId
        })
        if(feedbackInfo.data.status){
          feedbackInfo=feedbackInfo.data.data[0]
          this.feedbackInfo=feedbackInfo
          this.questionImageList=feedbackInfo.silist
          this.answerList=feedbackInfo.srlist
        }
      },
      clearCurrFeedbackId(){
        this.$emit('clearCurrFeedbackId')
      }
    },
    components: {},
    mounted() {
      this._initFeedbackInfo()
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .feedbackDetail
    .mask
      position absolute
      left 0
      right 0
      top 0
      bottom 0
      background rgba(0, 0, 0, 0.5)
      width 100%
      height 100%

    .main
      z-index 99
      overflow-y scroll
      padding 20px
      color #666666
      font-size 14px
      box-shadow 3px 3px 3px #666
      position absolute
      left 0
      right 0
      top 50px
      bottom 0
      margin auto
      background #f1f1f1
      .top
        border-bottom 1px solid #dddddd
        text-align center
        line-height 40px
        &>span
          float left
        &>h2
          font-size 16px
          color #666666
          display inline-block
        &>.back
          transition 300ms
          padding 0 10px
          cursor pointer
          &:hover
            color #004a94
            text-shadow 2px 2px 2px #cccccc
      .question,.answer
        border-bottom 1px solid #dddddd
        margin 20px 0
        &>h3.describe
          position relative
          padding-left 10px
          text-indent 0
          &::before
            content ""
            background-color #004a94
            display block
            width 3px
            height 1em
            margin auto
            position absolute
            left 0
            top 0
            bottom 0
        .describe
          margin 15px 0
          text-indent 2em
        .imageList
          li
            text-align center
            img
              margin auto
              width 100%
        .time
          text-align right
          color #999999
          margin-bottom 10px
</style>


// WEBPACK FOOTER //
// src/components/globalComp/feedbackDetail.vue